import * as api from './adapter';

export default {
  index: () => ({
    data: {
      data: [
        { id: '020b39f4', attributes: { name: '020b39f4' } },
        { id: '02db4ced', attributes: { name: '02db4ced' } },
        { id: '0ae61044', attributes: { name: '0ae61044' } },
        { id: '16c5924a', attributes: { name: '16c5924a' } },
        { id: '25e6146e', attributes: { name: '25e6146e' } },
        { id: '263afa97', attributes: { name: '263afa97' } },
        { id: '3341aee0', attributes: { name: '3341aee0' } },
        { id: '3e60c8ee', attributes: { name: '3e60c8ee' } },
        { id: '44a633c8', attributes: { name: '44a633c8' } },
        { id: '483b30e1', attributes: { name: '483b30e1' } },
        { id: '6f68a009', attributes: { name: '6f68a009' } },
        { id: '7fd42918', attributes: { name: '7fd42918' } },
        { id: '86f905ba', attributes: { name: '86f905ba' } },
        { id: '95d3e9d2', attributes: { name: '95d3e9d2' } },
        { id: 'b6181eb9', attributes: { name: 'b6181eb9' } },
      ],
      meta: { count: 19, page_count: 2 },
      links: {
        first: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=1&page%5Bsize%5D=15',
        next: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
        last: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
      },
    },
  }),
  /**
   * show
   * @param id
   * @return {Promise}
   */
  show: (id) => api.read(`/user_relatives/${id}`),
  /**
   * createCrewUser
   * @param attributes
   * @returns {Promise}
   */
  create: (attributes) => api.create({ type: 'user_relatives', attributes }),
  /**
   * updateCrewUser
   * @param id
   * @param attributes
   * @returns {Promise}
   */
  update: (id, attributes) => api.update({ id, type: 'user_relatives', attributes }),
  /**
   * deleteCrewUser
   * @returns {Promise<*>}
   */
  delete: (id) => api.destroy({ id, type: 'user_relatives' }),
};
